export default {"src":"/_next/static/image/public/images/ic_tick_grey.586aaa27e40b69e9e826de050c93ffad.svg","height":17,"width":17};